const updateUrlWithoutReload = (url) => {
  if (window.history) {
    window.history.replaceState({ path: url }, window.document.title, url);
  }
};
const updateUrlWithReload = (url) => {
  if (window.history) {
    window.history.pushState({ path: url }, window.document.title, url);
  }
};
const updateQueryParam = (queryParam, value) => {
  const url = new URL(window.location.href);
  url.searchParams.set(queryParam, value);
  window.history.replaceState(null, "", url.toString());
};
export {
  updateQueryParam,
  updateUrlWithReload,
  updateUrlWithoutReload
};
//# sourceMappingURL=update-url.js.map
